import { render, staticRenderFns } from "./GameResults.vue?vue&type=template&id=183238b0&"
import script from "./GameResults.vue?vue&type=script&lang=js&"
export * from "./GameResults.vue?vue&type=script&lang=js&"
import style0 from "./GameResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports